const prefix = 'notification';

const SET_MESSAGES = `${prefix}/SET_MESSAGES`;
const SET_TOTAL = `${prefix}/SET_TOTAL`;
const SET_LOADING = `${prefix}/SET_LOADING`;
const RESET = `${prefix}/RESET`;

export { SET_MESSAGES, SET_TOTAL, SET_LOADING, RESET };
